import { StateStatusEnum } from "@/enums/state-status.enum";

export const defaultReducers = {
  loading(state: any) {
    state.status = StateStatusEnum.LOADING;
    return state;
  },
  success(state: any) {
    state.status = StateStatusEnum.SUCCESS;
    return state;
  },
  failed(state: any) {
    state.status = StateStatusEnum.FAILED;
    return state;
  },
};
